(function () {
  'use strict';

  angular
    .module('itecAdministracio.entitats.main.formulari')
    .config(config);

function config($stateProvider) {
    $stateProvider
      .state('entitats.main.submain.formulari', {
        url: '/formulari',
        params: {
          isNew : false
        },
        views: {
          'headerSubmenu@': {
            templateUrl: 'shared/header-submenu/headerSubmenu.tpl.html',
            controller: 'HeaderSubmenuCtrl',
            controllerAs: 'vm',
            resolve: {
              optionsHeaderSubmenuData: function(entitatsHeaderSubmenuLinksValue){
                return entitatsHeaderSubmenuLinksValue;
              }
            }
          },
          'content@entitats.main.submain': {
            templateUrl: 'entitats/main/formulari/formulari.tpl.html',
            controller: 'EntitatsMainSubmainFormulariCtrl',
            controllerAs: 'ctrl'
          }
        }
      });
  }
}());
